import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import InternContainerComponent from './InternContainerComponent';
import collegeInternList from './CollegeTeam';
import UserInfoContainer from './UserInfoContainer';
import { connect } from 'react-redux';
import store, { cecPageNo, twaPageNo, mbaPageNo, schoolPageNo, collegePageNo } from '../../../redux/store';
// ES6 classNameNameNameName-style
class CollegeComponent extends PreLoginSessionCheck {
	constructor(props) {
		super(props);
		this.state = {
			profileData: null,
			userClicked: false
		}
	}
	componentDidMount() {
		this.setState({ profileData: null, userClicked: false });
	}
	hideFn = (profileData) => {
		this.setState({ profileData: profileData, userClicked: true });
	}
	closeFn = () => {
		this.setState({ profileData: null, userClicked: false });
	}
	render() {
		return (

			<div>
				{
					(() => {
						if (this.state.userClicked) {
							return (
								<UserInfoContainer userData={this.state.profileData} closeFn={this.closeFn}></UserInfoContainer>
							)
						} else {
							return (
								<InternContainerComponent getPageValue={this.props.getPageValue} decrementFn={this.props.decrementFn} incrementFn={this.props.incrementFn} profileClickedFn={this.hideFn} internList={collegeInternList}></InternContainerComponent>
							)
						}
					})()
				}
			</div>

		);
	}
}
const getStateData = (state) => {
	return {
		getPageValue: () => {
			//console.log("removeData ");
			return state.collegePageNo
		}
	}
}

const setStateData = (dispatch) => {
	return {
		incrementFn: () => {
			//console.log("addData ",addData);
			dispatch({ type: "college_pageno_increment" })
		},
		decrementFn: () => {
			//console.log("removeData ");
			dispatch({ type: "college_pageno_decrement" })
		}
	}
}

export default connect(getStateData, setStateData)(CollegeComponent);


/* <section className="mtb product-main founder">
				<div className="container ourteamcontainer">
					<div className="">
						<div className="col-12 row d-flex flex-center teamimgcontainer teamcontent">
							{
								(() => {
									if (this.state.userClicked) {
										return (
											<UserInfoContainer userData={this.state.profileData} closeFn={this.closeFn}></UserInfoContainer>
										)
									} else {
										return (
											<InternContainerComponent getPageValue={this.props.getPageValue} decrementFn={this.props.decrementFn} incrementFn={this.props.incrementFn} profileClickedFn={this.hideFn} internList={collegeInternList}></InternContainerComponent>
										)
									}
								})()
							}
						</div>
					</div>
				</div>
			</section > */


// WEBPACK FOOTER //
// ./src/prelogin/src/components/CollegeComponent.js